// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".title-list-sorting-switch__popover--selected{--color:var(--ion-color-primary)}", ""]);
// Exports
module.exports = exports;
